import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--documents--print"
export default class extends Controller {
  connect() {
  }

  print() {
    console.log("Printing document...")
  }
}
